import React from "react";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "../ui/button";

export function ErrorState({ title, body, onRetry, testId = "error-state" }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex min-h-[280px] flex-col items-center justify-center rounded-lg border border-status-unavailable/20 bg-status-unavailable/5 px-6 py-12 text-center"
      data-testid={testId}
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-status-unavailable/10">
        <AlertTriangle className="h-5 w-5 text-status-unavailable" />
      </div>
      <h3 className="text-base font-semibold text-text-primary">{title}</h3>
      {body && (
        <p className="mt-2 max-w-sm text-sm text-text-secondary">{body}</p>
      )}
      {onRetry && (
        <Button
          variant="outline"
          onClick={onRetry}
          data-testid={`${testId}-retry`}
          className="mt-4 border-status-unavailable/30 text-status-unavailable hover:bg-status-unavailable/10"
        >
          {t("common.retry")}
        </Button>
      )}
    </div>
  );
}
